import { motion } from "framer-motion";
import {
  EMOTIONS,
  REACTION_CAPTIONS,
} from "../../constants/emotions";

/**
 * Inline emotion reaction sticker that appears under each chat message.
 *
 * `size`:
 *   - "sm" → widget surface (smaller avatar + text)
 *   - "md" → full page surface (bigger and more breathable)
 */
export default function EmotionSticker({
  emotion = "happy",
  caption,
  align = "left",
  size = "sm",
}) {
  const src = EMOTIONS[emotion] || EMOTIONS.idle;
  const captionText = caption || REACTION_CAPTIONS[emotion] || REACTION_CAPTIONS.happy;

  const wrapperClass =
    size === "md"
      ? `mt-2 flex items-center gap-2 ${align === "right" ? "justify-end" : "justify-start"}`
      : `mt-1.5 flex ${align === "right" ? "justify-end" : "justify-start"}`;

  const pillClass =
    size === "md"
      ? "flex items-center gap-2 rounded-full border border-purple-100 bg-white/95 px-3 py-1.5 shadow-sm"
      : "flex items-center gap-2 rounded-full border border-purple-100 bg-white/95 px-2.5 py-1 shadow-sm";

  const avatarClass =
    size === "md"
      ? "relative inline-flex h-11 w-11 overflow-hidden rounded-full bg-gradient-to-br from-purple-100 to-pink-100 ring-1 ring-purple-200"
      : "relative inline-flex h-9 w-9 overflow-hidden rounded-full bg-gradient-to-br from-purple-100 to-pink-100 ring-1 ring-purple-200";

  const captionClass =
    size === "md"
      ? "text-[12px] font-semibold text-[#5b1f6e]"
      : "text-[11px] font-semibold text-[#5b1f6e]";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.85, y: 6 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 240, damping: 18 }}
      className={wrapperClass}
    >
      <div className={pillClass}>
        <span className={avatarClass}>
          <motion.img
            key={src}
            src={src}
            alt={emotion}
            draggable={false}
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.25 }}
            className="h-full w-full select-none object-cover"
          />
        </span>
        <span className={captionClass}>{captionText}</span>
      </div>
    </motion.div>
  );
}
